import { useSelector } from 'react-redux';

import { RootState } from '@store';

export const useCommonSlice = () => {
  const commonSliceStates = useSelector((state: RootState) => state.CommonReducer);

  return commonSliceStates;
};
